<div>
    <p class="tw-mb-0" [innerHTML]="'adminPerformanceProfiles.restoreDialog.description{{profileName}}' | transloco:{profileName: profileData?.name}"></p>
    <div class="tw-flex tw-justify-end tw-mt-6">
        <p-button
            [label]="'adminPerformanceProfile.restoreDialog.cancelBtnLabel' | transloco"
            severity="secondary"
            variant="text"
            class="tw-mr-4"
            data-test="admin-performance-profile-restore-cancel-button"
            (onClick)="cancel()"
        />
        <p-button
            [label]="'adminPerformanceProfile.restoreDialog.restoreBtnLabel' | transloco"
            severity="primary"
            data-test="admin-performance-profile-restore-confirm-button"
            (onClick)="confirm()"
        />
    </div>
</div>
